<template>
  <b-form class="mb-3" @submit.prevent>
    <form-input
      v-model="form.full_name"
      rules="required"
      label="الاسم الكامل"
    />

    <b-form-group label="الجنس">
      <b-form-radio-group
        v-model="form.gender"
        :options="genderOptions"
        name="radios-gender"
      />
    </b-form-group>
    <form-select
      label="تاريخ الولادة"
      id="dob"
      :options="getYears()"
      rules="required"
      v-model="form.dob"
    />
    <form-cleave
      v-model="form.mobile_number"
      rules="required|min:10"
      label="رقم الهاتف (واتساب)"
      isNumber
      :charsCount="10"
    />
    <form-input
      v-model="form.email"
      rules="required|email"
      label="البريد الالكتروني"
    />
    <form-select
      label="محافظة الإقامة"
      :getOptionLabel="(x) => x.name_ar"
      :reduce="(x) => x.id"
      id="resGov"
      ep="v2/guest/selects/governorates"
      ref="resGov"
      rules="required"
      v-model="form.residence_id"
      @optionsFetched="onOptionsFetched"
    />
    <form-input
      v-model="form.academic_degree"
      rules="required"
      label="الشهادة العلمية"
    />

    <form-select
      label="صفة المشارك (ضمن الكيان المجتمعي)"
      id="social-role"
      :options="['موظف', 'عضو مجلس أمناء/إدارة', 'متطوع', 'عضو', 'غير ذلك']"
      rules="required"
      v-model="form.social_role"
    />
    <form-input
      v-if="form.social_role === 'غير ذلك'"
      v-model="form.social_role_other"
      rules="required"
      placeholder="صفة المشارك ضمن الكيان المجتمعي"
      name="صفة المشارك ضمن الكيان المجتمعي"
    />
    <form-select
      label="نوع الكيان المجتمعي"
      id="social-role"
      :options="[
        'مؤسسة',
        'جمعية',
        'رابطة',
        'منتدى',
        'فريق تطوعي ',
        'اتحاد',
        'نادي',
        'هيئة روحية',
        'غير ذلك',
      ]"
      rules="required"
      v-model="form.social_entity_type"
    />
    <form-input
      v-if="form.social_entity_type === 'غير ذلك'"
      v-model="form.social_entity_type_other"
      rules="required"
      placeholder="نوع الكيان المجتمعي"
      name="نوع الكيان المجتمعي"
    />
    <form-input
      v-model="form.work_place_type"
      rules="required"
      label="اسم الكيان المجتمعي"
    />

    <form-input v-model="form.work_field" rules="required" label="مجال العمل" />
    <form-cleave
      v-model="form.experience"
      rules="required"
      label="عدد سنوات الخبرة بالعمل المجتمعي"
    />
  </b-form>
</template>

<script>
import FormCleave from "@/components/FormCleave";
import FormSelect from "@/components/form-select";
import FormMask from "@/components/form-mask";
import FormInput from "@/components/form-input";

import { BForm, BFormRadioGroup, BFormGroup } from "bootstrap-vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  props: ["value"],
  components: {
    FormMask,
    FormCleave,
    FormSelect,
    BForm,
    BFormRadioGroup,
    BFormGroup,
    FormInput,
  },
  data() {
    return {
      genderOptions: [
        { text: "ذكر", value: true },
        { text: "أنثى", value: false },
      ],
    };
  },

  methods: {
    ...mapMutations("resGov", ["setOptions"]),
    onOptionsFetched() {
      var filtered = this.options.filter(
        (e) => ![1, 11, 12, 13].includes(e.id)
      );
      this.setOptions(filtered);
    },
    getYears() {
      var x = [];
      for (let index = 1940; index <= 2010; index++) {
        x.push(`${index}`);
      }
      return x.reverse();
    },
  },

  computed: {
    form: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    ...mapGetters("resGov", ["options"]),
  },
  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
